import React from 'react';
import { PopoverContent, type PopoverTypes } from '@fiverr-private/popover';
import { DropdownMenuContext } from '../DropdownMenu/useMenuContext';
import useDropdownContext from '../Dropdown/useDropdownContext';
import type { DropdownContentProps } from './types';
import useContent from './useContent';

import styles from './index.module.scss';

const DropdownContent = ({
  children,
  appendToBody,
}: DropdownContentProps & Pick<PopoverTypes.PopoverContentProps, 'appendToBody'>) => {
  const { searchWhenClosed } = useDropdownContext();
  const content = useContent();

  return (
    <PopoverContent
      disablePadding
      renderWhenClosed={searchWhenClosed}
      disableBoxShadow
      appendToBody={appendToBody}
      animationType="slideFade"
      onAnimationStart={content.onAnimationStart}
    >
      <DropdownMenuContext.Provider value={content}>
        <div className={styles.container}>{children}</div>
      </DropdownMenuContext.Provider>
    </PopoverContent>
  );
};

export default DropdownContent;
